import React, { useState } from 'react';
import { appFirebase } from '../../../firebase/credenciales';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

import Swal from 'sweetalert2';
import './ActivateSeller.css'

const storage = getStorage(appFirebase);

const ActivateSeller = ({ usuario, onActivateSeller }) => {
    //console.log(usuario)
  const [telefono, setTelefono] = useState(usuario?.tel || '');
  const [nequi, setNequi] = useState(usuario?.nequi || ''); // Para el número de Nequi
  const [identificacion, setIdentificacion] = useState(usuario?.cc || ''); // Para el número de identificación
  const [experiencia, setExperiencia] = useState(usuario?.experiencia || ''); // Años de experiencia
  const [isActivated, setIsActivated] = useState(usuario?.vendedor || false);
  const [foto, setFoto] = useState(null); // Estado para almacenar la foto



  const handleActivate = async() => {
    // Validar que todos los campos requeridos estén completos
    if (!telefono || !nequi || !identificacion || !experiencia || !foto) {
      Swal.fire('¡Ojo!', 'Por favor, complete todos los campos antes de activar su cuenta.', 'warning');
      return;
    }
    const storageRef = ref(storage, `vendedores/${foto.name}`);  // Crear una referencia en el almacenamiento
    await uploadBytes(storageRef, foto);  // Subir el archivo
    const fileUrl = await getDownloadURL(storageRef);
    // Lógica para activar al vendedor
    onActivateSeller({ telefono, nequi, identificacion, experiencia, foto:fileUrl });
    setIsActivated(true);
    //Swal.fire('¡Éxito!', 'Ahora eres un vendedor activo en MEGALOTO.', 'success');
  };
  // Función para crear los enlaces de compartir
const getShareUrl = (platform, url) => {
    const encodedUrl = encodeURIComponent(url);
    switch (platform) {
      case 'whatsapp':
        return `https://wa.me/?text=${encodedUrl}`;
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet?url=${encodedUrl}`;
      case 'email':
        return `mailto:?subject=Únete a MEGALOTO&body=Te invito a unirte a MEGALOTO. ${encodedUrl}`;
      default:
        return '#';
    }
  };
  const shareUrl = `https://megaloto-express.web.app/Vendedor?vendedorId=${usuario.uid}`; // El enlace de la página actual para compartir
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setFoto(file);
    } else {
      Swal.fire('Archivo no válido', 'Por favor, sube una imagen válida.', 'error');
    }
  };
  return (
    <div className="activate-seller">
      {!isActivated &&(
          <>
          <h2>¡Actívate como Vendedor en MEGALOTO!</h2>
          <p>Como vendedor, podrás ganar un porcentaje de las recargas y premios de tus referidos. ¡Una oportunidad única para generar ingresos extras!</p>
          <div className="benefits-section">
            <h3>Beneficios de ser vendedor:</h3>
            <ul>
              <li><strong>Comisión por recargas</strong>: 10% de cada recarga de tus referidos.</li>
              <li><strong>Comisión por premios</strong>: 40% del premio de tu referido si gana un sorteo.</li>
              <li><strong>Comisión por referidos de segundo nivel</strong>: 5% del monto de la recarga o premio de tus segundos referidos.</li>
              <li><strong>Comisión por premios de segundo nivel</strong>: 10% si un segundo nivel gana un premio.</li>
            </ul>
            <p>¡Cuanto más referidos, más ganancias!</p>
          </div>
          
          <form className="activate-form">
            <div className="form-group">
              <label htmlFor="telefono">Número de Teléfono</label>
              <input
                type="tel"
                id="telefono"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                placeholder="Ejemplo: 3001234567"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="nequi">Número de Nequi</label>
              <input
                type="tel"
                id="nequi"
                value={nequi}
                onChange={(e) => setNequi(e.target.value)}
                placeholder="Ejemplo: 3001234567"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="identificacion">Número de Identificación</label>
              <input
                type="tel" // Cambiado a number
                id="identificacion"
                value={identificacion}
                onChange={(e) => setIdentificacion(e.target.value)}
                placeholder="Ejemplo: 123456789"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="experiencia">Años de experiencia en ventas</label>
              <input
                type="number" // Cambiado a number
                id="experiencia"
                value={experiencia}
                onChange={(e) => setExperiencia(e.target.value)}
                placeholder="Ejemplo: 5 años"
                min="0" // Asegura que solo se puedan ingresar números positivos
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="foto">Sube una foto (preferiblemente sin fondo)</label>
              <input
                type="file"
                id="foto"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
              {foto && (
                <div className="photo-preview">
                  <p>Vista previa:</p>
                  <img src={URL.createObjectURL(foto)} alt="Vista previa de la foto" />
                </div>
              )}
              <p className="help-text">
                Si no sabes cómo eliminar el fondo de tu foto, <a href="mailto:ayuda@megaloto.com">contáctanos</a> y te ayudaremos.
              </p>
            </div>
            <button type="button" className="btn-activate" onClick={handleActivate}>
              Activar Cuenta como Vendedor
            </button>
          </form>
        </>
      ) }
      {isActivated && !usuario.vendedor&&(
        <div className="activated">
            <h3>¡Estamos Actualizando tus datos!</h3>
            <p>Gracias por unirte a nuestro programa de vendedores. en unos minutos podras comenzar a generar comisiones por tus referidos.</p>
        </div>
      )}
      {usuario.vendedor && (
        
        <div className="activated">
        <h3>¡Ya eres un vendedor activo!</h3>
        <p>Gracias por unirte a nuestro programa de vendedores. Ahora puedes comenzar a generar comisiones por tus referidos.</p>

        {/* Botón para compartir en redes sociales */}
        <div className="share-buttons">
            <h4>puedes ver tu LandingPage personalizada en : <a href={shareUrl}>{shareUrl}</a></h4>
          <p>Comparte tu enlace de vendedor con tus amigos y comienza a ganar comisiones:</p>
          <p>tus referidos activos son: {usuario.referidos.length}</p>

          <div className="share-links">
            <a href={getShareUrl('whatsapp', shareUrl)} target="_blank" rel="noopener noreferrer" className="share-button whatsapp">
              <i className="fab fa-whatsapp"></i> Compartir en WhatsApp
            </a>
            <a href={getShareUrl('facebook', shareUrl)} target="_blank" rel="noopener noreferrer" className="share-button facebook">
              <i className="fab fa-facebook"></i> Compartir en Facebook
            </a>
            <a href={getShareUrl('twitter', shareUrl)} target="_blank" rel="noopener noreferrer" className="share-button twitter">
              <i className="fab fa-twitter"></i> Compartir en Twitter
            </a>
            <a href={getShareUrl('email', shareUrl)} target="_blank" rel="noopener noreferrer" className="share-button email">
              <i className="fas fa-envelope"></i> Compartir por Email
            </a>
          </div>
        </div>
      </div>
          
      )}
    </div>
  );
};

export default ActivateSeller;
